export const overlay = (theme) => ({
    appBar: {
        position: "relative",
        height: 64,
        padding: "0 8px 0 8px !important",
        background: "white",
    },
    icon: {
        height: 24,
        width: 24,
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
});
